import React, { useEffect, useState } from 'react';

function HTMLPage({ filePath }) {
  const [htmlContent, setHtmlContent] = useState('');

  useEffect(() => {
    fetch(filePath)
      .then(response => response.text())
      .then(text => setHtmlContent(text));
  }, [filePath]);

  return (
    
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    
  );
}

export default HTMLPage;